export default __webpack_public_path__ + "static/media/blog-post-4.8f16ffe7.jpg";